<template>
  <svg>
    <use :xlink:href="path" />
  </svg>
</template>

<script>
import {
  getPath,
  getBrandPath,
  getProductCollectionsPath,
  getCrafterpayPath,
  getPrintPath,
  getNeckLabelsPath
} from "common/utils/ui/use_svg";

export default {
  name: "UseSvg",
  props: {
    icon: {
      required: true,
      type: String
    },
    type: {
      validator(value) {
        return [
          "jiffy",
          "product_collections",
          "crafterpay",
          "brand_page",
          "print",
          "neck_labels"
        ].includes(value);
      },
      default: "jiffy"
    }
  },
  computed: {
    path() {
      let svgPath = getPath();

      if (this.type === "brand_page") {
        svgPath = getBrandPath();
      } else if (this.type === "product_collections") {
        svgPath = getProductCollectionsPath();
      } else if (this.type === "crafterpay") {
        svgPath = getCrafterpayPath();
      } else if (this.type === "print") {
        svgPath = getPrintPath();
      } else if (this.type === "neck_labels") {
        svgPath = getNeckLabelsPath();
      }

      return `${svgPath}#${this.icon}`;
    }
  }
};
</script>
